import SubmenuItem from '@linc-technologies/linced-common/components/submenu-item';

// This app overrides the addon's template with the co-located
// submenu-item.hbs in this directory. An explicit subclass (rather than a
// bare re-export) is required so the build can unambiguously associate
// that co-located template with this component instead of the addon's own.
export default class extends SubmenuItem {}
